module.exports = __webpack_public_path__ + "static/media/22.73f4a925.svg";